module.exports = __webpack_public_path__ + "static/media/Infra+LGPD.70aaabda.pdf";